module.exports = __webpack_public_path__ + "static/media/3moneysign-gray.b51b0629.svg";